module.exports = __webpack_public_path__ + "media/All Of Me.48a78afa.mp3";